import { TranslationContractMessages, ContractMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationContractMessages = {
  [ContractMessages.activeText]: "Text"
};
